const timeline = {
  title: "Timeline",
  left: 0, // 0 = erste Content-Box ist rechts, 1 = erste Content-Box ist links

  items: [
    {
      date: "Januar 2016",
      icon: "trending_up",
      headline: "Senior JavaScript Engineer",
      // content: ['Im Januar 2016 erhielt ich den Titel des Senior JavaScript Engineers.']
      content: [
        "Im Januar 2016 erhielt ich den Titel des <strong>Senior JavaScript Engineers</strong>."
        // ,'Ein zweiter schicker Absatz.'
      ]
    },
    {
      date: "2015",
      icon: "supervisor_account",
      headline: "Ausbilder nach AEVO",
      content: [
        "2015 schloss ich die <strong>Ausbildung zum Ausbilder</strong> nach der Ausbilder-Eignungsverordnung (AEVO) erfolgreich ab."
      ]
    },
    {
      date: "seit 2011",
      icon: "business_center",
      headline: "Web- und JavaScript-Entwickler",
      content: [
        "Seit dem Frühjahr 2011 bin ich in Festanstellung als <strong>Web- und JavaScript-Entwickler</strong> für ein weltweites Online-Shopsystem tätig."
      ]
    },
    {
      date: "2004-11",
      icon: "business_center",
      headline: "Selbständige Tätigkeit",
      content: [
        '2004 gründete ich die Agentur für Marketing, Consulting und Kommunikation "fun & work bei Quaese".'
      ]
    },
    {
      date: "2003",
      icon: "verified_user",
      headline: "Diplom-Ingenieur (FH)",
      content: [
        "2003 erwarb ich den akademischen Grad des Diplom-Ingenieurs (FH) mit der Gesamtnote 2,0."
      ]
    },
    {
      date: "1997-03",
      icon: "school",
      headline: "Studium Elektrotechnik (FH)",
      content: [
        "Studium der Elektrotechnik mit dem Schwerpunkt Daten- und Informationstechnik an der Fachhochschule (FH) in Coburg."
      ]
    },
    {
      date: "1993-97",
      icon: "school",
      headline: "Grundstudium Mathematik",
      content: [
        "Grundstudium im Diplomstudiengang der Mathematik mit Nebenfach Informatik an der Universität Bayreuth."
      ]
    },
    {
      date: "1993",
      icon: "location_city",
      headline: "Allgem. Hochschulreife (BOS)",
      content: [
        "Im Frühjahr 1993 legte ich die Ergänzungsprüfung im Fach Latein ab und erwarb damit die allgemeine Hochschulreife."
      ]
    },
    {
      date: "1991-93",
      icon: "school",
      headline: "Grundstudium Pädagogik",
      content: [
        "Während dieses Zeitraums besuchte ich die Veranstaltungen zum Grundstudium der Pädagogik (Soziologie/Anglistik) an der Universität Bayreuth."
      ]
    },
    {
      date: "1991",
      icon: "location_city",
      headline: "Hochschulreife (BOS)",
      content: [
        "Im Frühjahr 1991 erwarb ich an der staatlichen Berufsoberschule (BOS) in München die fachgebundene Hochschulreife."
      ]
    },
    {
      date: "1989",
      icon: "location_city",
      headline: "Fachschulreife (BAS)",
      content: [
        "Im Frühjahr 1989 erwarb ich an der Berufsaufbauschule (BAS) in Coburg die Fachschulreife."
      ]
    }
    // ,{
    //     date: '',
    //     icon: '',
    //     headline: '',
    //     content: ['']
    // }
  ]
};

export default timeline;
